import React from 'react';
import { cnMerge } from '../../../utils/utils';

export const Loader = ({ className, innerClassName, centered }) => (
  <div
    className={cnMerge({
      'flex align-center justify-center p-24': centered,
      className,
    })}
  >
    <div
      className={cnMerge(
        'inline-block h-10 w-10 border-slate-400 animate-spin rounded-full border-4 border-solid !border-e-transparent align-[-0.125em] text-surface motion-reduce:animate-[spin_1.5s_linear_infinite] dark:text-white',
        innerClassName
      )}
      role="status"
    >
      <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
        Loading...
      </span>
    </div>
  </div>
);
